const Logo = () => {
  return (
    <a
      href="/"
      className="block text-3xl font-extrabold text-green-300 transition-all duration-300 hover:text-earth-gray-50 md:text-4xl "
    >
      ck.xyz
    </a>
  );
};

export default Logo;
